export enum ArchiveFileTitleRuleFormInfoType {
  FORM_CODE = 'FORM_CODE',
  FORM_NAME = 'FORM_NAME',
  FORM_SN = 'FORM_SN',
}
